import {mapActions} from 'pinia';
import {useSidebarStore} from '../store/sidebarStore';

export default {
  methods: {
    ...mapActions(useSidebarStore, [
      'hideSidebar',
      'addContact',
      'addReservation',
      'showComment',
      'toggleFilter',
      'toggleFilterTitle',
      'toggleSidebar',
      'toggleReservationFilterPlanning',
      'toggleReservationFilterList',
      'toggleFacturationHoteFilterList',
    ]),
  },
};
